import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Licenses from "./pages/Licenses";
import Gallery from "./pages/Gallery";
import About from "./pages/About";
import Services from "./pages/Services";
import Team from "./pages/Team";
import Contact from "./pages/Contact";
import Client from "./pages/Client";
import "./App.css";

// Inisialisasi Google Analytics 4
ReactGA.initialize("G-VCQTGVHG5J");

// Komponent melacak pageview SPA secara dinamis
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return null;
};

const App = () => {
  // Domain Utama (Pastikan disamakan dengan Sitemap)
  const DOMAIN = "https://ptkamandanujayasamudera.com";

  // Schema.org Structured Data
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "PT Kamandanu Jaya Samudera",
    url: DOMAIN,
    logo: `${DOMAIN}/logo.png`,
    description:
      "Trusted Indonesian crew manning agency providing STCW-certified seafarers, maritime logistics, and comprehensive crew management solutions worldwide.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Jl. Warakas 3 No.23, RT.010 RW.004, Lantai 2",
      addressLocality: "Tanjung Priok, Jakarta Utara",
      postalCode: "14330",
      addressCountry: "ID",
    },
    telephone: "+62-21-43938505",
    email: "info@kamandanujayasamudera.com",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+62-813-1192-2417",
      contactType: "customer service",
      areaServed: "Global",
      availableLanguage: ["Indonesian", "English"],
    },
    sameAs: [
      "https://www.linkedin.com/company/pt-kamandanu-jaya-samudera",
      "https://www.instagram.com/kamandanujayasamudera_",
    ],
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
      </Helmet>

      <Router>
        <AnalyticsTracker />
        <div className="min-h-screen flex flex-col justify-between bg-white">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/licenses" element={<Licenses />} />
              <Route path="/services" element={<Services />} />
              <Route path="/team" element={<Team />} />
              <Route path="/client" element={<Client />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/gallery" element={<Gallery />} />
              
              {/* Redirect 404/Unknown URLs back to Home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
          <ScrollToTop />
        </div>
      </Router>
    </>
  );
};

export default App;